export type CampaignSource = "Google Ads" | "Meta Ads" | "WhatsApp" | "Instagram Bio" | "Tavsiye";

export interface Campaign {
  id: string;
  name: string;
  startDate: string;
  endDate: string;
  source: CampaignSource;
  customers: number;
  appointments: number;
  sales: number;
  revenue: number;
  active: boolean;
  budget: number;
  notes: string;
}

export const campaigns: Campaign[] = [
  {
    id: "cmp-001",
    name: "Yılbaşı Özel Spa Paketi",
    startDate: "2025-12-01",
    endDate: "2026-01-15",
    source: "Meta Ads",
    customers: 87,
    appointments: 64,
    sales: 42,
    revenue: 89000,
    active: false,
    budget: 12000,
    notes: "Yılbaşı hediye paketi kampanyası, çok başarılı dönüşüm.",
  },
  {
    id: "cmp-002",
    name: "Sevgililer Günü Çift Masajı",
    startDate: "2026-02-01",
    endDate: "2026-02-20",
    source: "Google Ads",
    customers: 56,
    appointments: 48,
    sales: 38,
    revenue: 72000,
    active: false,
    budget: 8500,
    notes: "Çift masaj paketi, Instagram reels ile desteklendi.",
  },
  {
    id: "cmp-003",
    name: "Bahar Detoks Kampanyası",
    startDate: "2026-03-15",
    endDate: "2026-04-30",
    source: "Meta Ads",
    customers: 72,
    appointments: 58,
    sales: 45,
    revenue: 95000,
    active: false,
    budget: 10000,
    notes: "Detoks SPA paketi, bahar temizliği konsepti.",
  },
  {
    id: "cmp-004",
    name: "Ramazan Sonrası Gevşeme",
    startDate: "2026-04-01",
    endDate: "2026-04-30",
    source: "Google Ads",
    customers: 45,
    appointments: 38,
    sales: 30,
    revenue: 52000,
    active: false,
    budget: 6000,
    notes: "Google arama ağı kampanyası.",
  },
  {
    id: "cmp-005",
    name: "Anneler Günü Özel",
    startDate: "2026-04-20",
    endDate: "2026-05-15",
    source: "Meta Ads",
    customers: 92,
    appointments: 76,
    sales: 61,
    revenue: 112000,
    active: true,
    budget: 15000,
    notes: "Devam eden kampanya, yüksek dönüşüm oranı.",
  },
  {
    id: "cmp-006",
    name: "Instagram Bio Link Kampanyası",
    startDate: "2026-01-01",
    endDate: "2026-12-31",
    source: "Instagram Bio",
    customers: 134,
    appointments: 98,
    sales: 72,
    revenue: 145000,
    active: true,
    budget: 0,
    notes: "Organik Instagram bio link üzerinden gelen müşteriler.",
  },
  {
    id: "cmp-007",
    name: "Tavsiye Programı",
    startDate: "2025-06-01",
    endDate: "2026-12-31",
    source: "Tavsiye",
    customers: 210,
    appointments: 168,
    sales: 135,
    revenue: 280000,
    active: true,
    budget: 15000,
    notes: "Mevcut müşteri tavsiyesi programı, %10 indirim hediyeli.",
  },
  {
    id: "cmp-008",
    name: "WhatsApp Toplu Mesaj",
    startDate: "2026-05-01",
    endDate: "2026-05-31",
    source: "WhatsApp",
    customers: 38,
    appointments: 28,
    sales: 22,
    revenue: 38000,
    active: true,
    budget: 0,
    notes: "Mevcut müşterilere özel fırsat mesajı.",
  },
];